import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  // §6.2: three across on desktop, one on mobile. CSS grid rather than MUI
  // <Grid container> — it is what ProviderForm, the canonical form screen,
  // uses, and it needs no <Grid item> wrapper around every field.
  inputsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    columnGap: 16,
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' }
  },
  traceAlert: {
    marginBottom: theme.spacing(2)
  },
  // §4.4: the save action sits in a footer, right-aligned.
  formActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  }
}))

export default useStyles
